import { frontendserverurl } from './../../../../environments/environment';
import { Component, inject } from '@angular/core';
import { FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppdataService } from '../../../service/appdata.service';
import { StreamService } from '../../../service/stream.service';

@Component({
  selector: 'app-newandeditagent',
  standalone: false,
  templateUrl: './newandeditagent.component.html',
  styleUrl: './newandeditagent.component.scss'
})
export class NewandeditagentComponent {
  readonly data = inject<any>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<NewandeditagentComponent>);
  hidespinner: boolean = true;
  isNew: boolean = !this.data.agent;
  frontendserverurl = frontendserverurl;
  llmavatars: any[] = [];
  industries: any[] = [];
  statuses: any[] = [];
  appTags: any[] = [];
  tags: any[] = [];

  /*
    let sql = `CREATE TABLE IF NOT EXISTS agents (
    id VARCHAR(36) NOT NULL,
    llmId VARCHAR(36),
    avatar VARCHAR(256),
    industryId VARCHAR(36),
    name VARCHAR(64),
    prompt TEXT,
    status VARCHAR(24),
    PRIMARY KEY (id)
  )`; */

  agentForm: any;

  constructor(
    private fb: FormBuilder,
    private appData: AppdataService,
    private streamService: StreamService
  ) {
    this.agentForm = this.fb.group({
      id: [this.data.agent?.id || ''],
      llmId: this.data.agent?.llmId || '',
      avatar: this.data.agent?.avatar || '',
      industryId: this.data.agent?.industryId || '',
      name: [this.data.agent?.name, Validators.required],
      prompt: [this.data.agent?.prompt, Validators.required],
      status: this.data.agent?.status,
      isDefault: this.data.agent?.isDefault || false,
    });
    this.loadData();
  }

  async deleteTag(tag: string) {
    this.tags = await this.tags.filter((t: any) => t.id !== tag);
  }
  async addTag(tag: string) {
    let tagToAdd = await this.appData.tags.find((t: any) => t.id === tag);
    if (this.tags.includes(tagToAdd)) return;

    this.tags.push(tagToAdd);
  }
  async loadData() {
    let result = await this.appData.loadAllLlmAvatars();
    if (result !== false) this.llmavatars = result;
    this.statuses = this.appData.statuses;
    this.industries = this.appData.industryTypes;
    this.appData.tags.forEach(async (tag: any) => {
      let tagCat = await this.appData.tagGroups.find(tagCat => tagCat.id === tag?.tagGroupId);
      let name = { id: tag.id, name: `${tagCat?.name} | ${tag.name}`, icon: tag.icon }
      this.appTags.push(name)

      if (this.data.agent?.tags.includes(tag.id)) this.tags.push(tag);
    });

  }
  selectAvatar(avatar: string, event: any) {
    this.agentForm.patchValue({ avatar });
    document.querySelectorAll('.avatar').forEach((el: any) => el.classList.remove('selected'));
    event.target.classList.add('selected');
  }
  cancel() {
    this.dialogRef.close();
  }
  async save() {
    if (this.agentForm.invalid) {


      return;
    }
    let finalTags = []
    for await (let tag of this.tags) {
      finalTags.push(tag.id);
    }
    this.agentForm.value.tags = finalTags;

    this.hidespinner = false;
    // Create New Agent
    if (this.agentForm.value.id == "" || !this.agentForm.value.id) {
      let rsult = await this.streamService.createNewAgent(this.agentForm.value);
      this.hidespinner = true;
      if (rsult !== false) this.dialogRef.close(true);
      return;
    }

    // Update Agent
    let result = await this.streamService.updateAgent(this.agentForm.value);
    this.hidespinner = true;
    if (result !== false) this.dialogRef.close(true);

  }
}
